<form [formGroup]="customerService.entity">
  <div class="customer-form">

    <!-- Card 1: Información General -->
    <div class="form-card">
      <div class="card-header">
        <h3><i class="fa-solid fa-building"></i> Información General</h3>
      </div>
      <div class="card-content">
        <div class="form-grid">
          <!-- Tipo de Persona -->
          <div class="form-field">
            <label for="entity">
              <span class="p-error">*</span>Tipo de persona:
            </label>
            <p-dropdown
              formControlName="entity"

              [panelStyle]="{'width': '100%' }"
              [style]="{'height': '45px'}"
              scrollHeight="150px"
              [options]="kinds"
              optionLabel="label"
              optionValue="value"
              [filter]="true"
              filterBy="label"
              [showClear]="true"
              placeholder="Selecciona un tipo de persona"
              (onChange)="onEntityChange($event.value)">
              <ng-template pTemplate="selectedItem">
                <div class="flex align-items-center" *ngIf="customerService.entity.get('entity')?.value">
                  <div>{{getKindCategory(customerService.entity.get('entity')?.value)}}</div>
                </div>
              </ng-template>
              <ng-template let-kind pTemplate="item">
                <div class="flex align-items-center">
                  <div>{{ kind.label }}</div>
                </div>
              </ng-template>
            </p-dropdown>
            <ng-container *ngIf="customerService.entity.get('entity')?.invalid && (customerService.entity.get('entity')?.dirty || customerService.entity.get('entity')?.touched)">
              <small class="p-error" *ngIf="customerService.entity.get('entity')?.errors?.['required']">El tipo de persona es obligatorio.</small>
            </ng-container>
          </div>

          <!-- Omnicanal: canal de origen (solo plataforma interna; gated por assign-channel) -->
          <div class="form-field" *appIfHasPermission="['omnichannel', 'assign-channel']">
            <label for="channelKey">Canal de origen (opcional):</label>
            <p-dropdown inputId="channelKey" formControlName="channelKey" [options]="(channelOptions$ | async) ?? []" optionLabel="label" optionValue="value" placeholder="Auto por defecto" [showClear]="true" [style]="{ width: '100%' }"></p-dropdown>
            <small class="channel-hint">* Si se deja vacío, el canal se asigna automáticamente según quién registra.</small>
          </div>

          <!-- Sector -->
          <div class="form-field">
            <label for="industrySector">
              <span class="p-error">*</span>Sector:
            </label>
            <input type="text" pInputText id="industrySector" formControlName="industrySector" placeholder="Introduce el sector" />
            <ng-container *ngIf="customerService.entity.get('industrySector')?.invalid && (customerService.entity.get('industrySector')?.dirty || customerService.entity.get('industrySector')?.touched)">
              <small class="p-error" *ngIf="customerService.entity.get('industrySector')?.errors?.['required']">El sector es obligatorio.</small>
            </ng-container>
          </div>

          <!-- Subsector -->
          <div class="form-field">
            <label for="industrySubsector">
              <span class="p-error">*</span>Subsector:
            </label>
            <input type="text" pInputText id="industrySubsector" formControlName="industrySubsector" placeholder="Introduce el subsector" />
            <ng-container *ngIf="customerService.entity.get('industrySubsector')?.invalid && (customerService.entity.get('industrySubsector')?.dirty || customerService.entity.get('industrySubsector')?.touched)">
              <small class="p-error" *ngIf="customerService.entity.get('industrySubsector')?.errors?.['required']">El subsector es obligatorio.</small>
            </ng-container>
          </div>
        </div>
      </div>
    </div>

    <!-- Card 2: Datos Personales -->
    <div class="form-card">
      <div class="card-header">
        <h3><i class="fa-solid fa-user"></i> Datos Personales</h3>
      </div>
      <div class="card-content">
        <div class="form-grid">
          <!-- Nombre -->
          <div class="form-field">
            <label for="name">
              <span class="p-error">*</span>Nombre:
            </label>
            <input type="text" pInputText id="name" formControlName="name" placeholder="Introduce el nombre" />
            <ng-container *ngIf="customerService.entity.get('name')?.invalid && (customerService.entity.get('name')?.dirty || customerService.entity.get('name')?.touched)">
              <small class="p-error" *ngIf="customerService.entity.get('name')?.errors?.['required']">El nombre es obligatorio.</small>
              <small class="p-error" *ngIf="customerService.entity.get('name')?.errors?.['minlength']">El nombre debe tener al menos 3 caracteres.</small>
            </ng-container>
          </div>

          <!-- Razón Social -->
          <div class="form-field" *ngIf="customerService.entity.get('entity')?.value === 'Moral'">
            <label for="legalName">
              <span class="p-error">*</span>Razón Social:
            </label>
            <input type="text" pInputText id="legalName" formControlName="legalName" placeholder="Introduce la Razón Social" />
            <ng-container *ngIf="customerService.entity.get('legalName')?.invalid && (customerService.entity.get('legalName')?.dirty || customerService.entity.get('legalName')?.touched)">
              <small class="p-error" *ngIf="customerService.entity.get('legalName')?.errors?.['required']">La Razón Social es obligatoria.</small>
              <small class="p-error" *ngIf="customerService.entity.get('legalName')?.errors?.['minlength']">La Razón Social debe tener al menos 3 caracteres.</small>
            </ng-container>
          </div>

          <!-- Apellido Paterno -->
          <div class="form-field" *ngIf="customerService.entity.get('entity')?.value === 'Física'">
            <label for="lastName">
              <span class="p-error">*</span>Apellido paterno:
            </label>
            <input type="text" pInputText id="lastName" formControlName="lastName" placeholder="Introduce el apellido paterno" />
            <ng-container *ngIf="customerService.entity.get('lastName')?.invalid && (customerService.entity.get('lastName')?.dirty || customerService.entity.get('lastName')?.touched)">
              <small class="p-error" *ngIf="customerService.entity.get('lastName')?.errors?.['required']">El apellido paterno es obligatorio.</small>
              <small class="p-error" *ngIf="customerService.entity.get('lastName')?.errors?.['minlength']">El apellido paterno debe tener al menos 3 caracteres.</small>
            </ng-container>
          </div>

          <!-- Apellido Materno -->
          <div class="form-field" *ngIf="customerService.entity.get('entity')?.value === 'Física'">
            <label for="middleName">
              <span class="p-error">*</span>Apellido materno:
            </label>
            <input type="text" pInputText id="middleName" formControlName="middleName" placeholder="Introduce el apellido materno" />
            <ng-container *ngIf="customerService.entity.get('middleName')?.invalid && (customerService.entity.get('middleName')?.dirty || customerService.entity.get('middleName')?.touched)">
              <small class="p-error" *ngIf="customerService.entity.get('middleName')?.errors?.['required']">El apellido materno es obligatorio.</small>
              <small class="p-error" *ngIf="customerService.entity.get('middleName')?.errors?.['minlength']">El apellido materno debe tener al menos 3 caracteres.</small>
            </ng-container>
          </div>

          <!-- Nacionalidad -->
          <div class="form-field" *ngIf="customerService.entity.get('entity')?.value === 'Física'">
            <label for="nationality">
              <span class="p-error">*</span>Nacionalidad:
            </label>
            <p-dropdown formControlName="nationality" appendTo="body" [panelStyle]="{'width': '100%' }" [style]="{'height': '45px'}" scrollHeight="150px" [options]="nationalities" optionLabel="label" optionValue="value" [filter]="true" filterBy="label" [showClear]="true" placeholder="Selecciona una nacionalidad">
              <ng-template pTemplate="selectedItem">
                <div class="flex align-items-center" *ngIf="customerService.entity.get('nationality')?.value">
                  <div>{{getNationality(customerService.entity.get('nationality')?.value)}}</div>
                </div>
              </ng-template>
              <ng-template let-nationality pTemplate="item">
                <div class="flex align-items-center">
                  <div>{{ nationality.label }}</div>
                </div>
              </ng-template>
            </p-dropdown>
            <ng-container *ngIf="customerService.entity.get('nationality')?.invalid && (customerService.entity.get('nationality')?.dirty || customerService.entity.get('nationality')?.touched)">
              <small class="p-error" *ngIf="customerService.entity.get('nationality')?.errors?.['required']">La nacionalidad es obligatoria.</small>
            </ng-container>
          </div>
        </div>
      </div>
    </div>

    <!-- Card 3: Información Fiscal -->
    <div class="form-card">
      <div class="card-header">
        <h3><i class="fa-solid fa-file-invoice"></i> Información Fiscal</h3>
      </div>
      <div class="card-content">
        <div class="form-grid">
          <!-- RFC -->
          <div class="form-field">
            <label for="rfc">
              <span class="p-error">*</span>RFC:
            </label>
            <input type="text" pInputText id="rfc" formControlName="rfc" placeholder="XXXX000000XX0" />
            <ng-container *ngIf="customerService.entity.get('rfc')?.invalid && (customerService.entity.get('rfc')?.dirty || customerService.entity.get('rfc')?.touched)">
              <small class="p-error" *ngIf="customerService.entity.get('rfc')?.errors?.['required']">El RFC es obligatorio.</small>
              <small class="p-error" *ngIf="customerService.entity.get('rfc')?.errors?.['pattern']">El RFC no tiene un formato válido.</small>
            </ng-container>
          </div>

          <!-- Régimen Fiscal -->
          <div class="form-field">
            <label for="fiscalRegime">
              <span class="p-error">*</span>Régimen Fiscal:
            </label>
            <p-dropdown
              formControlName="fiscalRegime"

              [panelStyle]="{'width': '100%' }"
              [style]="{'height': '45px'}"
              scrollHeight="250px"
              [options]="customerService.fiscalRegimes"
              optionLabel="label"
              optionValue="value"
              [filter]="true"
              filterBy="label"
              [showClear]="true"
              placeholder="Selecciona un régimen fiscal">
            </p-dropdown>
            <ng-container *ngIf="customerService.entity.get('fiscalRegime')?.invalid && (customerService.entity.get('fiscalRegime')?.dirty || customerService.entity.get('fiscalRegime')?.touched)">
              <small class="p-error" *ngIf="customerService.entity.get('fiscalRegime')?.errors?.['required']">El régimen fiscal es obligatorio.</small>
            </ng-container>
          </div>

          <!-- CURP -->
          <div class="form-field" *ngIf="customerService.entity.get('entity')?.value === 'Física'">
            <label for="curp">
              <span class="p-error">*</span>CURP:
            </label>
            <input type="text" pInputText id="curp" formControlName="curp" placeholder="XXXX000000HDFRRV00" />
            <ng-container *ngIf="customerService.entity.get('curp')?.invalid && (customerService.entity.get('curp')?.dirty || customerService.entity.get('curp')?.touched)">
              <small class="p-error" *ngIf="customerService.entity.get('curp')?.errors?.['required']">El CURP es obligatorio.</small>
              <small class="p-error" *ngIf="customerService.entity.get('curp')?.errors?.['pattern']">El CURP no tiene un formato válido.</small>
            </ng-container>
          </div>
        </div>
      </div>
    </div>

    <!-- Card 4: Contacto Principal -->
    <div class="form-card">
      <div class="card-header">
        <h3><i class="fa-solid fa-phone"></i> Contacto Principal</h3>
      </div>
      <div class="card-content">
        <div class="form-grid">
          <!-- Email -->
          <div class="form-field">
            <label for="email">
              <span class="p-error">*</span>Email:
            </label>
            <input type="text" pInputText id="email" formControlName="email" placeholder="correo@gmail.com" />
            <ng-container *ngIf="customerService.entity.get('email')?.invalid && (customerService.entity.get('email')?.dirty || customerService.entity.get('email')?.touched)">
              <small class="p-error" *ngIf="customerService.entity.get('email')?.errors?.['required']">El correo es obligatorio.</small>
              <small class="p-error" *ngIf="customerService.entity.get('email')?.errors?.['email']">El correo no tiene un formato válido.</small>
            </ng-container>
          </div>

          <!-- Teléfono -->
          <div class="form-field">
            <label for="phone">
              <span class="p-error">*</span>Teléfono:
            </label>
            <p-inputMask mask="9999999999" id="phone" formControlName="phone" placeholder="10 dígitos" [autoClear]="false" [style]="{'width':'100%'}"></p-inputMask>
            <ng-container *ngIf="customerService.entity.get('phone')?.invalid && (customerService.entity.get('phone')?.dirty || customerService.entity.get('phone')?.touched)">
              <small class="p-error" *ngIf="customerService.entity.get('phone')?.errors?.['required']">El teléfono es obligatorio.</small>
              <small class="p-error" *ngIf="customerService.entity.get('phone')?.errors?.['pattern']">El teléfono debe tener exactamente 10 dígitos.</small>
            </ng-container>
          </div>
        </div>
      </div>
    </div>

    <!-- Card 5: Información Financiera -->
    <div class="form-card">
      <div class="card-header">
        <h3><i class="fa-solid fa-chart-pie"></i> Información Financiera</h3>
      </div>
      <div class="card-content">
        <div class="form-grid">
          <!-- Ingresos Anuales -->
          <div class="form-field">
            <label for="anualIncome">
              <span class="p-error">*</span>Ingresos Anuales:
            </label>
            <p-inputNumber formControlName="anualIncome" inputId="anualIncome" mode="currency" currency="MXN" locale="es-MX"></p-inputNumber>
            <ng-container *ngIf="customerService.entity.get('anualIncome')?.invalid && (customerService.entity.get('anualIncome')?.dirty || customerService.entity.get('anualIncome')?.touched)">
              <small class="p-error" *ngIf="customerService.entity.get('anualIncome')?.errors?.['required']">Los ingresos anuales son obligatorios.</small>
            </ng-container>
          </div>

          <!-- Total de empleados -->
          <div class="form-field">
            <label for="employees">
              <span class="p-error">*</span>Total de empleados:
            </label>
            <p-inputNumber inputId="employees" formControlName="employees" [min]="0" [useGrouping]="false" [style]="{'width':'100%'}"></p-inputNumber>
            <ng-container *ngIf="customerService.entity.get('employees')?.invalid && (customerService.entity.get('employees')?.dirty || customerService.entity.get('employees')?.touched)">
              <small class="p-error" *ngIf="customerService.entity.get('employees')?.errors?.['required']">El total de empleados es obligatorio.</small>
            </ng-container>
          </div>
        </div>
      </div>
    </div>

    <!-- Card 6: Domicilio Operativo -->
    <div class="form-card" formGroupName="address">
      <div class="card-header">
        <h3><i class="fa-solid fa-location-dot"></i> Domicilio Operativo</h3>
      </div>
      <div class="card-content">
        <div class="form-grid">
          <!-- Calle -->
          <div class="form-field full-width">
            <label for="street">
              <span class="p-error">*</span>Calle:
            </label>
            <input type="text" pInputText id="street" formControlName="street" placeholder="Ingresa la calle" />
            <ng-container *ngIf="customerService.entity.get('address.street')?.invalid && (customerService.entity.get('address.street')?.dirty || customerService.entity.get('address.street')?.touched)">
              <small class="p-error" *ngIf="customerService.entity.get('address.street')?.errors?.['required']">La calle es obligatoria.</small>
            </ng-container>
          </div>

          <!-- Número Exterior -->
          <div class="form-field">
            <label for="exteriorNumber">Número exterior:</label>
            <input type="text" pInputText id="exteriorNumber" formControlName="exteriorNumber" placeholder="Ingresa el número exterior" />
          </div>

          <!-- Número Interior -->
          <div class="form-field">
            <label for="interiorNumber">Número interior:</label>
            <input type="text" pInputText id="interiorNumber" formControlName="interiorNumber" placeholder="Ingresa el número interior" />
          </div>

          <!-- Colonia -->
          <div class="form-field">
            <label for="colony">
              <span class="p-error">*</span>Colonia:
            </label>
            <input type="text" pInputText id="colony" formControlName="colony" placeholder="Colonia" />
            <ng-container *ngIf="customerService.entity.get('address.colony')?.invalid && (customerService.entity.get('address.colony')?.dirty || customerService.entity.get('address.colony')?.touched)">
              <small class="p-error" *ngIf="customerService.entity.get('address.colony')?.errors?.['required']">La colonia es obligatoria.</small>
            </ng-container>
          </div>

          <!-- Ciudad -->
          <div class="form-field">
            <label for="city">
              <span class="p-error">*</span>Ciudad:
            </label>
            <input type="text" pInputText id="city" formControlName="city" placeholder="Ciudad" />
            <ng-container *ngIf="customerService.entity.get('address.city')?.invalid && (customerService.entity.get('address.city')?.dirty || customerService.entity.get('address.city')?.touched)">
              <small class="p-error" *ngIf="customerService.entity.get('address.city')?.errors?.['required']">La ciudad es obligatoria.</small>
            </ng-container>
          </div>

          <!-- Municipio -->
          <div class="form-field">
            <label for="municipality">
              <span class="p-error">*</span>Municipio:
            </label>
            <input type="text" pInputText id="municipality" formControlName="municipality" placeholder="Municipio" />
            <ng-container *ngIf="customerService.entity.get('address.municipality')?.invalid && (customerService.entity.get('address.municipality')?.dirty || customerService.entity.get('address.municipality')?.touched)">
              <small class="p-error" *ngIf="customerService.entity.get('address.municipality')?.errors?.['required']">El municipio es obligatorio.</small>
            </ng-container>
          </div>

          <!-- Estado -->
          <div class="form-field">
            <label for="state">
              <span class="p-error">*</span>Estado:
            </label>
            <input type="text" pInputText id="state" formControlName="state" placeholder="Estado" />
            <ng-container *ngIf="customerService.entity.get('address.state')?.invalid && (customerService.entity.get('address.state')?.dirty || customerService.entity.get('address.state')?.touched)">
              <small class="p-error" *ngIf="customerService.entity.get('address.state')?.errors?.['required']">El estado es obligatorio.</small>
            </ng-container>
          </div>

          <!-- Código Postal -->
          <div class="form-field">
            <label for="postalCode">
              <span class="p-error">*</span>Código Postal:
            </label>
            <input type="text" pInputText id="postalCode" formControlName="postalCode" placeholder="Código postal" />
            <ng-container *ngIf="customerService.entity.get('address.postalCode')?.invalid && (customerService.entity.get('address.postalCode')?.dirty || customerService.entity.get('address.postalCode')?.touched)">
              <small class="p-error" *ngIf="customerService.entity.get('address.postalCode')?.errors?.['required']">El código postal es obligatorio.</small>
              <small class="p-error" *ngIf="customerService.entity.get('address.postalCode')?.errors?.['pattern']">El código postal solo puede contener 5 números sin letras.</small>
            </ng-container>
          </div>

          <!-- País -->
          <div class="form-field">
            <label for="country">
              <span class="p-error">*</span>País:
            </label>
            <input type="text" pInputText id="country" formControlName="country" placeholder="País" />
            <ng-container *ngIf="customerService.entity.get('address.country')?.invalid && (customerService.entity.get('address.country')?.dirty || customerService.entity.get('address.country')?.touched)">
              <small class="p-error" *ngIf="customerService.entity.get('address.country')?.errors?.['required']">El país es obligatorio.</small>
            </ng-container>
          </div>
        </div>
      </div>
    </div>

    <!-- Card 7: Domicilio Fiscal (solo Moral) -->
    <div class="form-card" *ngIf="customerService.entity.get('entity')?.value === 'Moral'">
      <div class="card-header">
        <h3><i class="fa-solid fa-building-columns"></i> Domicilio Fiscal</h3>
      </div>
      <div class="card-content">
        <div class="checkbox-field">
          <p-checkbox
            [binary]="true"
            formControlName="sameLegalAddress"
            label="La dirección fiscal es la misma que la dirección operativa"
          ></p-checkbox>
        </div>

        <div class="form-grid" formGroupName="legalAddress" *ngIf="customerService.entity.get('sameLegalAddress')?.value === false">
          <!-- Calle -->
          <div class="form-field full-width">
            <label for="legalStreet">
              <span class="p-error">*</span>Calle:
            </label>
            <input type="text" pInputText id="legalStreet" formControlName="street" placeholder="Ingresa la calle" />
            <ng-container *ngIf="customerService.entity.get('legalAddress.street')?.invalid && (customerService.entity.get('legalAddress.street')?.dirty || customerService.entity.get('legalAddress.street')?.touched)">
              <small class="p-error" *ngIf="customerService.entity.get('legalAddress.street')?.errors?.['required']">La calle es obligatoria.</small>
            </ng-container>
          </div>

          <!-- Número Exterior -->
          <div class="form-field">
            <label for="legalExteriorNumber">Número exterior:</label>
            <input type="text" pInputText id="legalExteriorNumber" formControlName="exteriorNumber" placeholder="Ingresa el número exterior" />
          </div>

          <!-- Número Interior -->
          <div class="form-field">
            <label for="legalInteriorNumber">Número interior:</label>
            <input type="text" pInputText id="legalInteriorNumber" formControlName="interiorNumber" placeholder="Ingresa el número interior" />
          </div>

          <!-- Colonia -->
          <div class="form-field">
            <label for="legalColony">
              <span class="p-error">*</span>Colonia:
            </label>
            <input type="text" pInputText id="legalColony" formControlName="colony" placeholder="Colonia" />
            <ng-container *ngIf="customerService.entity.get('legalAddress.colony')?.invalid && (customerService.entity.get('legalAddress.colony')?.dirty || customerService.entity.get('legalAddress.colony')?.touched)">
              <small class="p-error" *ngIf="customerService.entity.get('legalAddress.colony')?.errors?.['required']">La colonia es obligatoria.</small>
            </ng-container>
          </div>

          <!-- Ciudad -->
          <div class="form-field">
            <label for="legalCity">
              <span class="p-error">*</span>Ciudad:
            </label>
            <input type="text" pInputText id="legalCity" formControlName="city" placeholder="Ciudad" />
            <ng-container *ngIf="customerService.entity.get('legalAddress.city')?.invalid && (customerService.entity.get('legalAddress.city')?.dirty || customerService.entity.get('legalAddress.city')?.touched)">
              <small class="p-error" *ngIf="customerService.entity.get('legalAddress.city')?.errors?.['required']">La ciudad es obligatoria.</small>
            </ng-container>
          </div>

          <!-- Municipio -->
          <div class="form-field">
            <label for="legalMunicipality">
              <span class="p-error">*</span>Municipio:
            </label>
            <input type="text" pInputText id="legalMunicipality" formControlName="municipality" placeholder="Municipio" />
            <ng-container *ngIf="customerService.entity.get('legalAddress.municipality')?.invalid && (customerService.entity.get('legalAddress.municipality')?.dirty || customerService.entity.get('legalAddress.municipality')?.touched)">
              <small class="p-error" *ngIf="customerService.entity.get('legalAddress.municipality')?.errors?.['required']">El municipio es obligatorio.</small>
            </ng-container>
          </div>

          <!-- Estado -->
          <div class="form-field">
            <label for="legalState">
              <span class="p-error">*</span>Estado:
            </label>
            <input type="text" pInputText id="legalState" formControlName="state" placeholder="Estado" />
            <ng-container *ngIf="customerService.entity.get('legalAddress.state')?.invalid && (customerService.entity.get('legalAddress.state')?.dirty || customerService.entity.get('legalAddress.state')?.touched)">
              <small class="p-error" *ngIf="customerService.entity.get('legalAddress.state')?.errors?.['required']">El estado es obligatorio.</small>
            </ng-container>
          </div>

          <!-- Código Postal -->
          <div class="form-field">
            <label for="legalPostalCode">
              <span class="p-error">*</span>Código Postal:
            </label>
            <input type="text" pInputText id="legalPostalCode" formControlName="postalCode" placeholder="Código postal" />
            <ng-container *ngIf="customerService.entity.get('legalAddress.postalCode')?.invalid && (customerService.entity.get('legalAddress.postalCode')?.dirty || customerService.entity.get('legalAddress.postalCode')?.touched)">
              <small class="p-error" *ngIf="customerService.entity.get('legalAddress.postalCode')?.errors?.['required']">El código postal es obligatorio.</small>
              <small class="p-error" *ngIf="customerService.entity.get('legalAddress.postalCode')?.errors?.['pattern']">El código postal solo puede contener 5 números sin letras.</small>
            </ng-container>
          </div>

          <!-- País -->
          <div class="form-field">
            <label for="legalCountry">
              <span class="p-error">*</span>País:
            </label>
            <input type="text" pInputText id="legalCountry" formControlName="country" placeholder="País" />
            <ng-container *ngIf="customerService.entity.get('legalAddress.country')?.invalid && (customerService.entity.get('legalAddress.country')?.dirty || customerService.entity.get('legalAddress.country')?.touched)">
              <small class="p-error" *ngIf="customerService.entity.get('legalAddress.country')?.errors?.['required']">El país es obligatorio.</small>
            </ng-container>
          </div>
        </div>
      </div>
    </div>

    <!-- Card 8: Contactos Adicionales -->
    <div class="form-card">
      <div class="card-header">
        <h3><i class="fa-solid fa-users"></i> Contactos Adicionales</h3>
        <span class="contact-count" *ngIf="customerService.contacts.length > 0">
          {{ customerService.contacts.length }} contacto{{ customerService.contacts.length !== 1 ? 's' : '' }}
        </span>
      </div>
      <div class="card-content">
        <div formArrayName="contacts">
          <div *ngFor="let contact of customerService.contacts.controls; let i = index" [formGroupName]="i" class="contact-item">
            <div class="contact-item-header">
              <h4>
                <i class="fa-solid fa-user-tie"></i>
                Contacto {{ i + 1 }}
              </h4>
              <button pButton type="button" icon="pi pi-trash" class="p-button-danger p-button-text p-button-rounded p-button-sm" pTooltip="Eliminar contacto" tooltipPosition="left" (click)="customerService.removeContact(i)"></button>
            </div>
            <div class="form-grid">
              <!-- Tipo de Contacto -->
              <div class="form-field">
                <label>
                  <span class="p-error">*</span>Tipo de Contacto:
                </label>
                <p-dropdown
                  [options]="customerService.contactTypes"
                  formControlName="contactType"
    
                  placeholder="Selecciona tipo de contacto"
                  optionLabel="label"
                  optionValue="value"
                  [style]="{'height': '45px'}">
                </p-dropdown>
              </div>

              <!-- Nombre -->
              <div class="form-field">
                <label>
                  <span class="p-error">*</span>Nombre:
                </label>
                <input type="text" pInputText formControlName="firstName" placeholder="Nombre del contacto" />
                <ng-container *ngIf="contact.get('firstName')?.invalid && (contact.get('firstName')?.dirty || contact.get('firstName')?.touched)">
                  <small class="p-error" *ngIf="contact.get('firstName')?.errors?.['required']">El nombre es obligatorio.</small>
                  <small class="p-error" *ngIf="contact.get('firstName')?.errors?.['minlength']">Debe tener al menos 3 caracteres.</small>
                </ng-container>
              </div>

              <!-- Apellido Paterno -->
              <div class="form-field">
                <label>Apellido Paterno:</label>
                <input type="text" pInputText formControlName="lastName" placeholder="Apellido Paterno" />
                <ng-container *ngIf="contact.get('lastName')?.invalid && (contact.get('lastName')?.dirty || contact.get('lastName')?.touched)">
                  <small class="p-error" *ngIf="contact.get('lastName')?.errors?.['required']">El apellido paterno es obligatorio.</small>
                  <small class="p-error" *ngIf="contact.get('lastName')?.errors?.['minlength']">Debe tener al menos 3 caracteres.</small>
                </ng-container>
              </div>

              <!-- Apellido Materno -->
              <div class="form-field">
                <label>Apellido Materno:</label>
                <input type="text" pInputText formControlName="middleName" placeholder="Apellido Materno" />
                <ng-container *ngIf="contact.get('middleName')?.invalid && (contact.get('middleName')?.dirty || contact.get('middleName')?.touched)">
                  <small class="p-error" *ngIf="contact.get('middleName')?.errors?.['required']">El apellido materno es obligatorio.</small>
                  <small class="p-error" *ngIf="contact.get('middleName')?.errors?.['minlength']">Debe tener al menos 3 caracteres.</small>
                </ng-container>
              </div>

              <!-- Correo Electrónico -->
              <div class="form-field">
                <label>
                  <span class="p-error">*</span>Correo Electrónico:
                </label>
                <input type="email" pInputText formControlName="email" placeholder="Correo del contacto" />
                <ng-container *ngIf="contact.get('email')?.invalid && (contact.get('email')?.dirty || contact.get('email')?.touched)">
                  <small class="p-error" *ngIf="contact.get('email')?.errors?.['required']">El correo es obligatorio.</small>
                  <small class="p-error" *ngIf="contact.get('email')?.errors?.['email']">El correo no es válido.</small>
                </ng-container>
              </div>

              <!-- Teléfono -->
              <div class="form-field">
                <label>
                  <span class="p-error">*</span>Teléfono:
                </label>
                <p-inputMask mask="9999999999" formControlName="phone" placeholder="10 dígitos" [autoClear]="false" [style]="{'width':'100%'}"></p-inputMask>
                <ng-container *ngIf="contact.get('phone')?.invalid && (contact.get('phone')?.dirty || contact.get('phone')?.touched)">
                  <small class="p-error" *ngIf="contact.get('phone')?.errors?.['required']">El teléfono es obligatorio.</small>
                  <small class="p-error" *ngIf="contact.get('phone')?.errors?.['pattern']">El teléfono debe tener exactamente 10 dígitos.</small>
                </ng-container>
              </div>

              <!-- RFC del contacto -->
              <div class="form-field">
                <label>RFC:</label>
                <input type="text" pInputText formControlName="rfc" placeholder="XXXX000000XX0" />
                <ng-container *ngIf="contact.get('rfc')?.invalid && (contact.get('rfc')?.dirty || contact.get('rfc')?.touched)">
                  <small class="p-error" *ngIf="contact.get('rfc')?.errors?.['pattern']">El RFC no tiene un formato válido.</small>
                </ng-container>
              </div>

              <!-- CURP del contacto -->
              <div class="form-field">
                <label>CURP:</label>
                <input type="text" pInputText formControlName="curp" placeholder="XXXX000000HDFRRV00" />
                <ng-container *ngIf="contact.get('curp')?.invalid && (contact.get('curp')?.dirty || contact.get('curp')?.touched)">
                  <small class="p-error" *ngIf="contact.get('curp')?.errors?.['pattern']">El CURP no tiene un formato válido.</small>
                </ng-container>
              </div>

              <!-- Posición -->
              <div class="form-field">
                <label>
                  <span class="p-error">*</span>Posición:
                </label>
                <input type="text" pInputText formControlName="position" placeholder="Administración" />
                <ng-container *ngIf="contact.get('position')?.invalid && (contact.get('position')?.dirty || contact.get('position')?.touched)">
                  <small class="p-error" *ngIf="contact.get('position')?.errors?.['required']">La posición del contacto es obligatoria.</small>
                  <small class="p-error" *ngIf="contact.get('position')?.errors?.['minlength']">La posición debe tener al menos 3 caracteres.</small>
                </ng-container>
              </div>

              <!-- Porcentaje de participación -->
              <div class="form-field">
                <label>Porcentaje de participación:</label>
                <p-inputNumber formControlName="participationPercentage" [min]="0" [max]="100" [maxFractionDigits]="2" [useGrouping]="false" placeholder="0 - 100" [style]="{'width':'100%'}"></p-inputNumber>
                <ng-container *ngIf="contact.get('participationPercentage')?.invalid && (contact.get('participationPercentage')?.dirty || contact.get('participationPercentage')?.touched)">
                  <small class="p-error" *ngIf="contact.get('participationPercentage')?.errors?.['min']">El porcentaje debe ser mayor o igual a 0.</small>
                  <small class="p-error" *ngIf="contact.get('participationPercentage')?.errors?.['max']">El porcentaje no debe exceder 100.</small>
                </ng-container>
              </div>
            </div>
          </div>
        </div>

        <div class="add-contact-action">
          <button pButton type="button" icon="pi pi-plus" label="Agregar Contacto" class="p-button-success p-button-outlined" (click)="customerService.addContact()"></button>
        </div>
      </div>
    </div>

  </div>
</form>
